/**
 * Reusable empty/placeholder state.
 *
 * `compact`: skips the `min-h-[50vh]` centering — for an empty state that
 * isn't the only thing on the page (e.g. sits inside a tab alongside a call-
 * to-action button below it), the forced half-viewport height pushes that
 * button below the fold for no reason; a full-page empty state still wants
 * the vertical centering, so this defaults to off.
 */
export function EmptyState({ title = 'Nothing here yet', description, icon: Icon, compact = false }) {
  return (
    <div
      className={`flex flex-col items-center text-center ${
        compact ? 'justify-center py-8' : 'min-h-[50vh] justify-center'
      }`}
    >
      {Icon && (
        <span className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-mist">
          <Icon className="h-8 w-8 text-slate" />
        </span>
      )}
      <h2 className="text-lg font-semibold text-ink">{title}</h2>
      {description && <p className="mt-1 max-w-sm text-sm text-slate">{description}</p>}
    </div>
  );
}

export default EmptyState;
